export const ONBOARD_PAYROLL_STARTED = "ONBOARD_PAYROLL_STARTED";
export const ONBOARD_PAYROLL_SUCCESS = "ONBOARD_PAYROLL_SUCCESS";
export const ONBOARD_PAYROLL_FAILED = "ONBOARD_PAYROLL_FAILED";

export const GET_ONBOARD_STATUS_STARTED = "GET_ONBOARD_STATUS_STARTED";
export const GET_ONBOARD_STATUS_SUCCESS = "GET_ONBOARD_STATUS_SUCCESS";
export const GET_ONBOARD_STATUS_FAILED = "GET_ONBOARD_STATUS_FAILED";

export const SET_PAYROLL_CONFIGURATION_STARTED = "SET_PAYROLL_CONFIGURATION_STARTED";
export const SET_PAYROLL_CONFIGURATION_SUCCESS = "SET_PAYROLL_CONFIGURATION_SUCCESS";
export const SET_PAYROLL_CONFIGURATION_FAILED = "SET_PAYROLL_CONFIGURATION_FAILED";

export const GET_PAYROLL_CONFIGURATION_STARTED = "GET_PAYROLL_CONFIGURATION_STARTED";
export const GET_PAYROLL_CONFIGURATION_SUCCESS = "GET_PAYROLL_CONFIGURATION_SUCCESS";
export const GET_PAYROLL_CONFIGURATION_FAILED = "GET_PAYROLL_CONFIGURATION_FAILED";

export const ADD_SINGLE_EMPLOYEE_STARTED = "ADD_SINGLE_EMPLOYEE_STARTED";
export const ADD_SINGLE_EMPLOYEE_SUCCESS = "ADD_SINGLE_EMPLOYEE_SUCCESS";
export const ADD_SINGLE_EMPLOYEE_FAILED = "ADD_SINGLE_EMPLOYEE_FAILED";

export const ADD_BULK_EMPLOYEES_STARTED = "ADD_BULK_EMPLOYEES_STARTED";
export const ADD_BULK_EMPLOYEES_SUCCESS = "ADD_BULK_EMPLOYEES_SUCCESS";
export const ADD_BULK_EMPLOYEES_FAILED = "ADD_BULK_EMPLOYEES_FAILED";

export const DELETE_EMPLOYEE_STARTED = "DELETE_EMPLOYEE_STARTED";
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS";
export const DELETE_EMPLOYEE_FAILED = "DELETE_EMPLOYEE_FAILED";

export const GET_EMPLOYEES_STARTED = "GET_EMPLOYEES_STARTED";
export const GET_EMPLOYEES_SUCCESS = "GET_EMPLOYEES_SUCCESS";
export const GET_EMPLOYEES_FAILED = "GET_EMPLOYEES_FAILED";
export const GET_MORE_EMPLOYEES_SUCCESS = "GET_MORE_EMPLOYEES_SUCCESS";
export const RESET_MORE_EMPLOYEES = "RESET_MORE_EMPLOYEES";

export const COMPLETE_ONBOARDING_STARTED = "COMPLETE_ONBOARDING_STARTED";
export const COMPLETE_ONBOARDING_SUCCESS = "COMPLETE_ONBOARDING_SUCCESS";
export const COMPLETE_ONBOARDING_FAILED = "COMPLETE_ONBOARDING_FAILED";

export const GET_FIRST_SCHEDULES_STARTED = "GET_FIRST_SCHEDULES_STARTE";
export const GET_FIRST_SCHEDULES_SUCCESS = "GET_FIRST_SCHEDULES_SUCCESS";
export const GET_FIRST_SCHEDULES_FAILED = "GET_FIRST_SCHEDULES_FAILED";

export const GET_SCHEDULES_STARTED = "GET_SCHEDULES_STARTED";
export const GET_SCHEDULES_SUCCESS = "GET_SCHEDULES_SUCCESS";
export const GET_SCHEDULES_FAILED = "GET_SCHEDULES_FAILED";

export const GET_NOT_ADDED_EMPLOYEES_STARTED = "GET_NOT_ADDED_EMPLOYEES_STARTED";
export const GET_NOT_ADDED_EMPLOYEES_SUCCESS = "GET_NOT_ADDED_EMPLOYEES_SUCCESS";
export const GET_NOT_ADDED_EMPLOYEES_FAILED = "GET_NOT_ADDED_EMPLOYEES_FAILED";

export const GET_PAYROLL_HISTORY_STARTED = "GET_PAYROLL_HISTORY_STARTED";
export const GET_PAYROLL_HISTORY_SUCCESS = "GET_PAYROLL_HISTORY_SUCCESS";
export const GET_PAYROLL_HISTORY_FAILED = "GET_PAYROLL_HISTORY_FAILED";

export const GET_HISTORY_DETAILS_STARTED = "GET_HISTORY_DETAILS_STARTED";
export const GET_HISTORY_DETAILS_SUCCESS = "GET_HISTORY_DETAILS_SUCCESS";
export const GET_HISTORY_DETAILS_FAILED = "GET_HISTORY_DETAILS_FAILED";

export const SET_SETUP_STAGE_SUCCESS = 'SET_SETUP_STAGE_SUCCESS';